<template>
    <div>
		<vs-dialog 
			:width="alert.width" 
			v-model="alert.show" 
			blur 
			not-close
			prevent-close>
			<template #header v-if="alert.title !== null">
				<h4 class="not-margin">
					{{ $t(alert.title) }}
				</h4>
			</template>

			<div v-if="Array.isArray(alert.message)">
				<mu-col class="text-center" v-for="(msg, index) of alert.message" :key="index">
					<span class="">
						{{ $t(msg) }}
					</span>
				</mu-col>
			</div>

			<div v-else-if="alert.html.message != null">
				<mu-col class="text-center">
					<div v-html="$t(alert.html.input, alert.html.message)" />
				</mu-col>
			</div>
			
			<div v-else>
				<span class="text-center">
					<mu-col class="text-center">
						<span class="">
							{{ $t(alert.message) }}
						</span>
					</mu-col>	
				</span>
			</div>

			<br>

			<template #footer>
				
				<div class="row">
					<div class="col text-center">
						<mu-button color="red" @click="closeAlert">
							{{ $t('button_action.close') }}
						</mu-button>
					</div>
				</div>
			</template>
		</vs-dialog>

        <!-- <mu-col>
            <mu-dialog  
				:title="(modal.full_screen) ? '' : $t(modal.title)" 
				width="600" 
				max-width="80%" 
				:esc-press-close="false" 
				:overlay-close="false" 
				:scrollable="modal.scrollable" 
				:fullscreen="modal.full_screen" 
				:transition="modal.transition" 
				:open.sync="modal.show">

				<mu-col v-if="!modal.full_screen">
					<mu-col class="text-center" v-for="(msg, index) of modal.message" :key="index">
						<span><b>{{ $t(msg) }}</b></span>
					</mu-col>
					<mu-col class="text-center my-2" v-if="!modal.cancel && !modal.payment">
						<mu-button slot="actions" class="border border-primary rounded " flat color="primary" @click="closeModal()">{{ $t('button_action.close') }}</mu-button>
					</mu-col>

					<mu-col class="text-center my-2" v-else-if="modal.cancel && !modal.payment">
						<mu-button  slot="actions" small class="rounded " color="error" @click="modal.accept(), closeModal()">{{ $t('button_action.leave') }}</mu-button>
						<mu-button slot="actions" small class="rounded " color="success" @click="closeModal()">{{ $t('button_action.continue') }}</mu-button>
					</mu-col>

					<mu-col class="text-center my-2" v-show="modal.payment">
						<a href="https://viajero.vallartaplus.mx/singin" target="_blank">
							<mu-button slot="actions" small class="rounded " color="success" @click="closeModal()">Registrarse</mu-button>
						</a>
						<a href="https://viajero.vallartaplus.mx" target="_blank">
							<mu-button slot="actions" small class="rounded " color="primary" @click="closeModal()">Iniciar Sesion</mu-button>
						</a>
						<mu-button slot="actions" small class="rounded " color="primary" @click="closeModal()">{{ $t('button_action.continue') }}</mu-button>
					</mu-col>
				</mu-col>
				


				<mu-col class="px-0" v-else>
					<mu-appbar class="text-center" color="primary" :title="modal.title">
						<mu-button slot="right" icon @click="closeModal()">
							<mu-icon value="close"></mu-icon>
						</mu-button>
					</mu-appbar>

					<mu-container  class="my-2">
						<mu-row class="section-container-text mb-3">
							<mu-col>
								<h4>{{ $t('header.h_1') }}</h4>

								<p>
									{{ $t('paragraph.p_1.content.ctn_1') }} <br>
									{{ $t('paragraph.p_1.content.ctn_2') }} <br>
									{{ $t('paragraph.p_1.content.ctn_3') }} <br>
									{{ $t('paragraph.p_1.content.ctn_4') }} <br>
									{{ $t('paragraph.p_1.content.ctn_5') }} <br>
									{{ $t('paragraph.p_1.content.ctn_6') }}<br>
									{{ $t('paragraph.p_1.content.ctn_7') }} <br>
									{{ $t('paragraph.p_1.content.ctn_8') }} <br>
									{{ $t('paragraph.p_1.content.ctn_9') }}
								</p>
								<p>
									{{ $t('paragraph.p_2.content.ctn_1') }} {{ $t('paragraph.p_2.link') }} {{ $t('paragraph.p_2.content.ctn_2') }}
								</p>
								<p>
									{{ $t('paragraph.p_3.content.ctn_1') }} <br>
									{{ $t('paragraph.p_3.content.ctn_2') }} <br>
									{{ $t('paragraph.p_3.content.ctn_3') }} <br>
									{{ $t('paragraph.p_3.content.ctn_4') }}
								</p>
								<p>
									{{ $t('sub_header.sbh_1') }}
								</p>
								<p> 
									<b>{{ $t('header.h_2') }}</b> 
									<ul class="check-list">
										<li>{{ $t('paragraph.p_4') }}</li>
									</ul>
								</p>
								<p>
									<b>{{ $t('header.h_3') }}</b><br>
									<ul class="check-list">
										<li>{{ $t('paragraph.p_5.content.ctn_1') }}</li>
										<li>{{ $t('paragraph.p_5.content.ctn_2') }}</li>
										<li>{{ $t('paragraph.p_5.content.ctn_3') }}</li>
										<li>{{ $t('paragraph.p_5.content.ctn_4') }}</li>
										<li>{{ $t('paragraph.p_5.content.ctn_5') }}</li>
									</ul>
								</p>
								
								<div class="row mt-4">
									<div class="col-12"><p> {{ $t('paragraph.p_5.content.ctn_6') }} </p></div>
									<div class="col-sm-6 col-md-6 col-lg-4 mb-3 px-4">
										<b-card class="h-100" :title="$t('card.crd_1.title')">
											<div class="text-center my-3">
												<picture>
													<source srcset="/images/card/clasica.webp" type="image/webp"  alt="Clásica" width="200px">
													<img src="/images/card/clasica.png" alt="Clásica" width="200px">
												</picture><br><br>
												<fa icon="suitcase" class="mr-1"/> {{ $t('card.crd_1.content.ctn_1') }}  <br> + <br>{{ $t('card.crd_1.content.ctn_2') }} <br> {{ $t('card.crd_1.content.ctn_3') }} <br> {{ $t('card.crd_1.content.ctn_4') }} <br> + <br> {{ $t('card.crd_1.content.ctn_5') }}
											</div>
										</b-card>
									</div>
									<div class="col-sm-6 col-md-6 col-lg-4 mb-3 px-4">
										<b-card class="h-100" :title="$t('card.crd_2.title')">
											<div class="text-center my-3">
												<picture>
													<source srcset="/images/card/oro.webp" type="image/webp"  alt="Oro" width="200px">
													<img src="/images/card/oro.png" alt="Oro" width="200px">
												</picture>
												<fa icon="suitcase" class="mr-1"/> {{ $t('card.crd_2.content.ctn_1') }}<br> + <br> 1 Equ{{ $t('card.crd_2.content.ctn_2') }} <br> {{ $t('card.crd_2.content.ctn_3') }} <br> {{ $t('card.crd_2.content.ctn_4') }} <br> + <br> {{ $t('card.crd_2.content.ctn_5') }}
											</div>
										</b-card>
									</div>
									<div class="col-sm-6 col-md-6 col-lg-4 mb-3 px-4">
										<b-card class="h-100" :title="$t('card.crd_3.title')">
											<div class="text-center my-3">
												<picture>
													<source srcset="/images/card/platino.webp" type="image/webp"  alt="Platino" width="200px">
													<img src="/images/card/platino.png" alt="Platino" width="200px">
												</picture>
												<fa icon="suitcase" class="mr-1"/> {{ $t('card.crd_3.content.ctn_1') }}<br> + <br> {{ $t('card.crd_3.content.ctn_2') }} <br> {{ $t('card.crd_3.content.ctn_3') }} <br> {{ $t('card.crd_3.content.ctn_4') }} <br> + <br> {{ $t('card.crd_3.content.ctn_5') }}
											</div>
										</b-card>
									</div>
								</div>
								<p>
									<ul class="check-list">
										<li>{{ $t('paragraph.p_5.content.ctn_7') }}</li>
										<li>{{ $t('paragraph.p_5.content.ctn_8') }}</li>
										<li>{{ $t('paragraph.p_5.content.ctn_9') }}</li>
										<li>{{ $t('paragraph.p_5.content.ctn_10') }}</li>
										<li>{{ $t('paragraph.p_5.content.ctn_11') }}</li>
									</ul>
								</p>
								<p>
									<b>{{ $t('header.h_4') }}</b><br>
									<ul class="check-list">
										<li>{{ $t('paragraph.p_6.content.ctn_1') }}</li>
										<li>{{ $t('paragraph.p_6.content.ctn_2') }}</li>
										<li>{{ $t('paragraph.p_6.content.ctn_3') }}</li>
									</ul>
								</p>
								<p>
									<b>{{ $t('header.h_5') }}</b><br>
									<ul class="check-list">
										<li>{{ $t('paragraph.p_7.content.ctn_1') }}</li>
										<li>{{ $t('paragraph.p_7.content.ctn_2') }}</li>
										<li>{{ $t('paragraph.p_7.content.ctn_3') }}</li>
										<li>{{ $t('paragraph.p_7.content.ctn_4') }}</li>
										<li>{{ $t('paragraph.p_7.content.ctn_5') }}</li>
									</ul>
								</p>
								<p>
									<b>{{ $t('header.h_6') }}</b><br>
									<ul class="check-list">
										<li>{{ $t('paragraph.p_8.content.ctn_1') }}</li>
										<li>{{ $t('paragraph.p_8.content.ctn_2') }}</li>
										<li>{{ $t('paragraph.p_8.content.ctn_3') }}</li>
										<li>{{ $t('paragraph.p_8.content.ctn_4') }}</li>
										<li>{{ $t('paragraph.p_8.content.ctn_5') }}</li>
										<li>{{ $t('paragraph.p_8.content.ctn_6') }}</li>
										<li>{{ $t('paragraph.p_8.content.ctn_7') }}</li>
										<li>{{ $t('paragraph.p_8.content.ctn_8') }}</li>
										<li>{{ $t('paragraph.p_8.content.ctn_9') }}</li>
										<li>{{ $t('paragraph.p_8.content.ctn_10') }}</li>
										<li>{{ $t('paragraph.p_8.content.ctn_11') }}</li>
										<li>{{ $t('paragraph.p_8.content.ctn_12') }}</li>
									</ul>
								</p>
								<p>
									<b>{{ $t('header.h_7') }}</b>
									<ul class="check-list">
										<li>{{ $t('paragraph.p_9.content.ctn_1') }}</li>
										<li>{{ $t('paragraph.p_9.content.ctn_2') }}</li>
										<li>{{ $t('paragraph.p_9.content.ctn_3') }}</li>
										<li>{{ $t('paragraph.p_9.content.ctn_4') }}</li>
									</ul>
								</p>
								<p>
									<b>{{ $t('header.h_8') }}</b>
									<ul class="check-list">
										<li>{{ $t('paragraph.p_10.content.ctn_1') }}</li>
										<li>{{ $t('paragraph.p_10.content.ctn_2') }}</li>
										<li>{{ $t('paragraph.p_10.content.ctn_3') }}</li>
									</ul>
								</p>
								<p>
									<b>{{ $t('header.h_9') }}</b> <br>
									{{ $t('paragraph.p_11') }}
								</p>
								<p>
									<b>{{ $t('header.h_10') }}</b>
									<ul class="check-list">
										<li>{{ $t('paragraph.p_12.content.ctn_1') }}</li>
										<li>{{ $t('paragraph.p_12.content.ctn_2') }}</li>
										<li>{{ $t('paragraph.p_12.content.ctn_3') }}</li>
										<li>{{ $t('paragraph.p_12.content.ctn_4') }}</li>
										<li>{{ $t('paragraph.p_12.content.ctn_5') }}</li>
									</ul>
								</p>
								<p>
									<b>{{ $t('header.h_11') }}</b>
									<ul class="check-list">
										<li>{{ $t('paragraph.p_13.content.ctn_1') }}</li>
										<li>{{ $t('paragraph.p_13.content.ctn_2') }}</li>
										<li>{{ $t('paragraph.p_13.content.ctn_3') }}</li>
										<li>{{ $t('paragraph.p_13.content.ctn_4') }}</li>
										<li>{{ $t('paragraph.p_13.content.ctn_5') }}</li>
										<li>{{ $t('paragraph.p_13.content.ctn_6') }}</li>
										<li>{{ $t('paragraph.p_13.content.ctn_7') }}</li>
										<li>{{ $t('paragraph.p_13.content.ctn_8') }}</li>
										<li>{{ $t('paragraph.p_13.content.ctn_9') }}</li>
										<li>{{ $t('paragraph.p_13.content.ctn_10') }}</li>
										<li>{{ $t('paragraph.p_13.content.ctn_11') }}</li>
									</ul>
								</p>
								<p>
									<b>{{ $t('header.h_12') }}</b> <br>
									{{ $t('paragraph.p_14') }}
								</p>
								<p>
									<b>{{ $t('header.h_13') }}</b> <br>
									{{ $t('paragraph.p_15.content.ctn_1') }} <br>
									{{ $t('paragraph.p_15.content.ctn_2') }} <br><br>
									<i>{{ $t('paragraph.p_15.content.ctn_3') }}</i>
								</p>
								<p>
									<b>{{ $t('header.h_14') }}</b> <br>
									{{ $t('paragraph.p_16') }}
								</p>
								<p>
									<b>{{ $t('header.h_15') }}</b> <br>
									{{ $t('paragraph.p_17') }}
								</p>
								<p>
									<b>{{ $t('header.h_16') }}</b> <br>
									{{ $t('paragraph.p_18') }}
								</p>
								<p>
									<b>{{ $t('header.h_17') }}</b> <br>
									{{ $t('paragraph.p_19') }}
								</p>
								<p>
									<b>{{ $t('header.h_18') }}</b><br>
									{{ $t('paragraph.p_20') }}
								</p>
								<p>
									<b>{{ $t('header.h_19') }}</b> <br>
									{{ $t('paragraph.p_21.content.ctn_1') }} <br>
									{{ $t('paragraph.p_21.content.ctn_2') }}  <br>
									{{ $t('paragraph.p_21.content.ctn_3') }}  <br><br>

									{{ $t('paragraph.p_21.content.ctn_4') }}  <br><br>

									{{ $t('sub_header.sbh_2') }}<br>{{ $t('paragraph.p_21.content.ctn_5') }}  <br> <br>

									{{ $t('sub_header.sbh_3') }}<br> {{ $t('paragraph.p_21.content.ctn_6') }}  <br>	<br>

									{{ $t('paragraph.p_21.content.ctn_7') }}  <br> <br>

									{{ $t('paragraph.p_21.content.ctn_8') }}  <br> <br>

									{{ $t('paragraph.p_21.content.ctn_9') }} <strong style="font-family: serif;">{{ $t('paragraph.p_21.content.ctn_10') }} </strong> <br> <br>

									{{ $t('paragraph.p_21.content.ctn_11') }}  <br>

									
								</p>
								<p>
									<b>{{ $t('header.h_2') }}</b> <br>
									<a href="https://www.gob.mx/cms/uploads/attachment/file/467350/Calendario_escolar_BASICA-1920.pdf ">{{ $t('paragraph.p_22.link') }}</a>
								</p>
								<p>
									<b>{{ $t('paragraph.p_22.note.title') }}</b> <br>
									{{ $t('paragraph.p_22.note.n_1') }} <br>
									<i>{{ $t('paragraph.p_22.note.n_2') }}</i>
								</p>
								<p>
									<b>{{ $t('header.h_21') }} </b> <br>
									{{ $t('paragraph.p_23') }}
									{{ $t('paragraph.p_23') }}
								</p>
								<p>
									<b>{{ $t('header.h_22') }}</b> <br>
									{{ $t('paragraph.p_24') }}
								</p>
								<p>
									<b>{{ $t('header.h_23') }}</b> <br>
								{{ $t('paragraph.p_25') }}
								</p>
								<p>
									<b>{{ $t('header.h_24') }}</b> <br>
									{{ $t('paragraph.p_26') }}
								</p>
								<p>
									<b>{{ $t('header.h_25') }}</b> <br>
									{{ $t('paragraph.p_27') }}
								</p>
								<p>
									<b>{{ $t('header.h_26') }}</b> <br>
									{{ $t('paragraph.p_28.content.ctn_1') }} <br><br>
								
									{{ $t('paragraph.p_28.content.ctn_2') }}<br>  <br>
							
									{{ $t('paragraph.p_28.content.ctn_3') }}<br><br>
								
									{{ $t('paragraph.p_28.content.ctn_4') }}<br><br>
							
									{{ $t('paragraph.p_28.content.ctn_5') }}<br><br>
								
									{{ $t('paragraph.p_28.content.ctn_6') }}
								</p>

							</mu-col>
						</mu-row>
						<mu-col class="my-2 text-center">
							<mu-button flat color="primary" class="border border-primary"  @click="closeModal()" >
								{{ $t('button_action.close') }}
							</mu-button>
						</mu-col>
					</mu-container>
				</mu-col>
			</mu-dialog>
        </mu-col> -->
    </div>
</template>

<script>
	// HELPERS
	import _GlobalHelper from '@/store/helpers/global'
	// VUEX
	import { mapActions, mapGetters, mapMutations } from 'vuex'
	// COMPONENTS
	import BCard from '@/components/BCard/Index'

    export default {
		name: 'alert-simple',
		components: {
			BCard: BCard
		},
		data() {
			return {
				show: false,
			}
		},
        computed: {
        	...mapGetters({
				alert: _GlobalHelper.getters.alert_simple
			}),
		},
		methods: {
			...mapMutations({
				setAlertSimple: _GlobalHelper.mutations.setAlertSimple
			}),

			closeAlert() {

				this.setAlertSimple({
					show: false,
					title: null,
					message: null,
					html: {
						message: null,
						input: null
					}
				})
			}
		},   
    }
</script>

<style lang="scss">
	.mu-dialog-title {
		color: #005296; 
		justify-content: space-around;
		border-top: black;
	}
	.mu-dialog-fullscreen {
		max-width: 78% !important;
		max-height: 86% !important;
		position: initial;
	}
	.mu-dialog-scrollable .mu-dialog-body {
		height: inherit;
	}
</style>